import { Component, OnInit } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar-routes.config';
import { MenuType } from '../sidebar/sidebar.metadata';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';

@Component({
    moduleId: module.id,
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit{
    private listTitles: any[];
    location: Location;
    heading : String;
    logout : String;
    
    constructor(location:Location) {
        this.location = location;
    }
    ngOnInit(){
        this.listTitles = ROUTES.filter(listTitle => listTitle.menuType !== MenuType.BRAND);
        this.languageSelector();
    }

    languageSelector(){

        let lang = localStorage.getItem('language');
        if(lang == "S"){
          this.heading = "කම්බි ප්රමාණය කැල්ක්යුලේටරය";
          this.logout = "පිට වීම";
        }else if(lang =="T"){
          this.heading = "கம்பி அளவு கால்குலேட்டர்";
          this.logout = "வெளியேறு";
        }else{
          this.heading = "Basic Information";
          this.logout = "Logout";
        }
    }
    getTitle(){
        var titlee = this.location.prepareExternalUrl(this.location.path());

        if(titlee.charAt(0) === '#'){
            titlee = titlee.slice( 2 );
        }

        for(var item = 0; item < this.listTitles.length; item++){
            if(this.listTitles[item].path === titlee){
                return this.listTitles[item].title;
            }
        }
        return 'Dashboard';
    }
}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts